import React from "react";

import john from "assets/images/users/avatar-2.jpg";
import sarah from "assets/images/users/avatar-10.jpg";
import michael from "assets/images/users/avatar-3.jpg";

function Testimonials() {
  const testimonials = [
    {
      name: "John Smith",
      position: "Operations Manager",
      company: "Elite Sportswear Inc.",
      text: "OrderRun has transformed our production process. We've reduced order processing time by 60% and improved inventory accuracy significantly.",
      avatar: john,
      rating: 5,
    },
    {
      name: "Sarah Johnson",
      position: "CEO",
      company: "Athletic Gear Co.",
      text: "The best investment we've made. The system handles everything from quotes to shipping seamlessly. Customer satisfaction has never been higher.",
      avatar: sarah,
      rating: 5,
    },
    {
      name: "Michael Chen",
      position: "Production Director",
      company: "ProSport Manufacturing",
      text: "Real-time production tracking and material management features are game-changers. We can now handle 3x more orders with the same team.",
      avatar: michael,
      rating: 5,
    },
  ];

  return (
    <section className="py-5 bg-light">
      <div className="container">
        <div className="row mb-5">
          <div className="col-12 text-center animate-on-scroll">
            <h1 className="display-5 fw-bold">
              <i className="mdi mdi-account-heart text-primary"></i>
            </h1>
            <h2 className="fw-bold">
              Trusted by <span className="text-primary">Industry Leaders</span>
            </h2>
            <p className="text-muted lead mt-3">
              See what our customers have to say about OrderRun
            </p>
          </div>
        </div>

        <div className="row">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="col-lg-4 col-md-6 mb-4 animate-on-scroll"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="card border-0 shadow-sm h-100 feature-card">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src={testimonial.avatar}
                      alt={testimonial.name}
                      className="rounded-circle me-3"
                      width="60"
                      height="60"
                    />
                    <div>
                      <h5 className="mb-0">{testimonial.name}</h5>
                      <small className="text-muted">
                        {testimonial.position}
                      </small>
                      <div className="text-warning">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <i key={i} className="mdi mdi-star"></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-muted mb-3">"{testimonial.text}"</p>
                  <small className="text-primary fw-bold">
                    {testimonial.company}
                  </small>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="row mt-5 animate-on-scroll">
          <div className="col-12">
            <div className="bg-primary bg-gradient rounded p-5 text-center text-white">
              <div className="row align-items-center">
                <div className="col-md-3 mb-3 mb-md-0">
                  <h2 className="display-4 fw-bold mb-0">500+</h2>
                  <p className="mb-0">Active Users</p>
                </div>
                <div className="col-md-3 mb-3 mb-md-0">
                  <h2 className="display-4 fw-bold mb-0">50K+</h2>
                  <p className="mb-0">Work Orders Processed</p>
                </div>
                <div className="col-md-3 mb-3 mb-md-0">
                  <h2 className="display-4 fw-bold mb-0">99.9%</h2>
                  <p className="mb-0">Uptime</p>
                </div>
                <div className="col-md-3">
                  <h2 className="display-4 fw-bold mb-0">24/7</h2>
                  <p className="mb-0">Support Available</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
